import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
  duration?: number;
}
export const FadeIn = ({
  children,
  delay = 0,
  direction = 'up',
  className = '',
  duration = 1
}: FadeInProps) => {
  const directions = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directions[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: duration,
    delay: delay,
    ease: [0.21, 0.47, 0.32, 0.98] // Custom ease-out for an elegant feel
  }} className={className} data-id="element-43">
      {children}
    </motion.div>;
};
export const Eyebrow = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={`flex items-center gap-4 mb-8 ${className}`} data-id="element-44">
    <div className="h-[1px] w-12 bg-taupe" data-id="element-45"></div>
    <span className="text-xs uppercase tracking-widest text-stone-light font-medium" data-id="element-46">
      {children}
    </span>
  </div>;